import React from 'react'

 const MailIcon = ({ iconColor = '#333333' }: { iconColor: string }) => {
    return (
        <span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
            >
                <path
                    d="M29.5 12.5V13.708C29.5 14.2497 29.3534 14.7812 29.0757 15.2463C28.798 15.7113 28.3995 16.0925 27.9227 16.3493L19.2853 21M3.5 12.5V13.708C3.49998 14.2497 3.6466 14.7812 3.92431 15.2463C4.20203 15.7113 4.60046 16.0925 5.07733 16.3493L13.7147 21M13.7147 21L15.0773 20.2667C15.5145 20.0312 16.0034 19.9079 16.5 19.9079C16.9966 19.9079 17.4855 20.0312 17.9227 20.2667L19.2867 21L25.5 24.3467M13.7147 21L7.5 24.3467M29.5 26.5C29.5 27.2957 29.1839 28.0587 28.6213 28.6213C28.0587 29.1839 27.2957 29.5 26.5 29.5H6.5C5.70435 29.5 4.94129 29.1839 4.37868 28.6213C3.81607 28.0587 3.5 27.2957 3.5 26.5V12.292C3.49998 11.7504 3.6466 11.2188 3.92431 10.7538C4.20203 10.2887 4.60046 9.90754 5.07733 9.65067L15.0773 4.26534C15.5145 4.02984 16.0034 3.90656 16.5 3.90656C16.9966 3.90656 17.4855 4.02984 17.9227 4.26534L27.9227 9.65067C28.3993 9.90743 28.7976 10.2884 29.0753 10.7532C29.353 11.218 29.4998 11.7492 29.5 12.2907V26.5Z"
                    stroke={iconColor}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}

export default MailIcon
